// Действия владельца протокола в строке «Документов», окне «Доступ» и шапке протокола (040).
// Владение — назначение lead с областью документа: его правило в /api/auth/me — «области», то есть
// «где-то есть». Чей это протокол, знает строка: показываем действие администратору (правило
// «всё») и нынешнему владельцу этого протокола — так проверяет и сервер (смена владельца —
// minutes.access.manage, перевод — minutes.transfer по области протокола). «Новый протокол»
// (documents.create) с 040 есть у каждого сотрудника и этих прав не даёт.
import type { MeResponse, Operation } from '@kp/contracts';

/** Владелец протокола, как его знает место вызова: строка «Документов», окно «Доступ», шапка. */
export interface OwnerRef {
  readonly userId: string;
}

type Viewer = Pick<MeResponse, 'permissions' | 'user'>;

/** Операция протокола доступна: администратору — везде, владельцу — в своём протоколе. */
export function canAsOwner(
  me: Viewer,
  operation: Operation,
  owner: OwnerRef | null | undefined,
): boolean {
  const rule = me.permissions[operation];
  if (rule === 'all') return true;
  return rule !== undefined && owner != null && owner.userId === me.user.id;
}

/** «Сменить владельца…»: администратору и нынешнему владельцу этого протокола. */
export function canChangeOwner(me: Viewer, owner: OwnerRef | null | undefined): boolean {
  return canAsOwner(me, 'minutes.access.manage', owner);
}
